export enum EComparisonToastCategory {
  Add = 'add',
  Remove = 'remove',
}

export interface IComparisonToastPayload {
  text: string;
  comparisonUrl?: string;
  isError: boolean;
  newbuildingId: number;
  category?: EComparisonToastCategory;
}
